define('presentation/settings/liveReceptionistScripts/viewModels/liveReceptionistScriptSubscribersTabViewModel',[
    'businessServices/authentication/sessionAccountInfo',
    'common/promises/promiseFactory',
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');

        self.subscriberSelectionViewModel = null;

        self.isImpersonating = ko.pureComputed(() => {
            return _sessionAccountInfo.isImpersonating();
        });

        self.getSubscribers = () => {
            return _promiseFactory.defer((promise) => {
                self.subscriberSelectionViewModel.getSubscribers()
                    .fail(promise.reject)
                    .done((getSubscribersResult) => {
                        promise.resolve(getSubscribersResult.subscribers);
                    });
            });
        };

        self.validate = () => {
            return _promiseFactory.defer((promise) => {
                self.subscriberSelectionViewModel.validate()
                    .fail(promise.reject)
                    .done((subscriberValidationResult) => {
                        promise.resolve(subscriberValidationResult);
                    });
            });
        };

        self.activate = (subscriberSelectionViewModel) => {
            if (subscriberSelectionViewModel) {
                self.subscriberSelectionViewModel = subscriberSelectionViewModel;
            }

            return _initialize();
        };

        const _initialize = () => {

            return _promiseFactory.wait();
        };
    };
});

